import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useBrandAccountId } from './useBrandAccountId'

const document = graphql(`
  mutation DocumentReportListPage_CreateDocumentReport(
    $brandAccountId: ID!
    $title: String!
  ) {
    createDocument(
      brandAccountId: $brandAccountId
      content: ""
      title: $title
    ) {
      id
    }
  }
`)

export const useCreateDocumentReportMutation = (
  options: MutationOptions<string, void> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { brandAccountId, title: t('untitled_document') },
      })
      const documentReportId = result.createDocument?.id
      if (!exists(documentReportId)) {
        throw new Error(t('creation_failed'))
      }

      return documentReportId
    },
    ...options,
  })
}
